import React from 'react';
export function WhatYoullLearn() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3184">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3185">
        <div className="mb-12" data-id="element-3186">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3187">
            What You'll Learn
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3188">
            <p className="text-base text-gray-800 mb-6 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3189">
              Develop your own personal safety plan covering a wide range of
              topics:
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-3190">
              {['Home Safety & Security', 'Automobile Safety', 'Phone & Communication Safety', 'Technology & Online Safety', 'Personal Safety Strategies', 'Crime Prevention Awareness'].map(topic => <div key={topic} className="flex items-center gap-3" data-id="element-3191">
                  <div className="w-2 h-2 rounded-full flex-shrink-0" style={{
                backgroundColor: '#c8a84b'
              }} data-id="element-3192" />
                  <span className="text-base text-gray-800" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-3193">
                    {topic}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}